<template>
  <Content stretch>
    <slot>no flanker component specified</slot>
  </Content>
</template>

<script>
import essExamProps from '@/mixins/essExamProps'
import { Content } from '@neurotrack/web-shared-components'
import { mapMutations, mapState } from 'vuex'
import { ntDate } from '@neurotrack/web-core'

export default {
  name: 'exam_flanker',
  components: { Content },
  mixins: [essExamProps],
  data() {
    return {
      countdown: null,
      trialStartTime: null
    }
  },
  created() {
    this.unsubscribe = this.$store.subscribe(mutation => {
      if (mutation.type === 'hideModal') {
        this.$emit('next')
      }
    })
  },
  watch: {
    trial: {
      immediate: true,
      handler: 'handleTrialWatcher'
    },
    isExamComplete(complete) {
      if (complete) {
        this.completeExam()
      }
    }
  },
  mounted() {
    window.addEventListener('keyup', this.dismissModal)
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.dismissModal)
    this.unsubscribe()
  },
  computed: {
    ...mapState(['modalVisible']),
    examPhase() {
      return this.isPractice ? 'practice' : 'exam'
    }
  },
  methods: {
    completeExam() {
      this.$store.dispatch(`exam/${this.exam}/complete`, undefined, {
        root: true
      })
    },
    trackEvent(perception) {
      this.$store.dispatch(`exam/${this.exam}/trackEvent`, perception, {
        root: true
      })
    },
    ...mapMutations(['showModal', 'hideModal']),
    dismissModal({ code }) {
      if (this.modalVisible && code === 'Space') {
        this.hideModal()
      }
    },
    handlePracticeFeedback({ event, trial }) {
      const answer = event.key.toLowerCase() === 'z' ? 'left' : 'right'
      // eslint-disable-next-line no-unused-vars
      const expected = trial.trial_scoring_type.split('_')[1]
      const correct = expected === answer
      this.$store.commit('showModal', {
        component: 'ArrowDirection',
        props: {
          expected,
          answer,
          correct
        },
        title: correct
          ? this.$i18n.t('arrow_match_tutorial_feedback_header_correct')
          : this.$i18n.t('arrow_match_tutorial_feedback_header_incorrect')
      })
    },
    handleExamResponse(response) {
      let answer
      if (response?.event?.key) {
        answer = response?.event?.key.toLowerCase() === 'z' ? 'left' : 'right'
      }

      const data = answer ? [{ type: 'selection', value: answer }] : []
      if (this.trial.trial_scoring_type) {
        this.trackEvent({
          exam_trial_id: this.trial.exam_trial_id,
          trial_start_time: this.trialStartTime,
          trial_end_time: ntDate.now(),
          metadata: {
            trial_scoring_type: this.trial.trial_scoring_type
          },
          data,
          timeout: !answer
        })
      }
    },
    handleResponse({ event, trial }) {
      if (this.modalVisible) {
        return
      }
      if (this.isPractice) {
        this.handlePracticeFeedback({ event, trial })
        this.handleExamResponse({ event, trial })
      } else {
        this.handleExamResponse({ event, trial })
        this.$emit('next')
      }
    },
    handleTrialWatcher(newValue) {
      this.trialStartTime = ntDate.now()
      if (!this.isPractice && newValue.display_seconds) {
        clearTimeout(this.countdown)
        this.countdown = setTimeout(() => {
          this.handleExamResponse(null)
          this.$emit('next')
        }, newValue.display_seconds * 1000)
      }
    }
  }
}
</script>

<style scoped></style>
